import { computed, ref, watch } from 'vue'
import { useAppearanceStore } from '@/features/appearance/store'
import { copyAppearance } from '@/features/appearance/preferences'

export function useAppearanceDraft() {
  const store = useAppearanceStore()
  const draft = ref(copyAppearance(store.saved))
  const baseline = ref(JSON.stringify(store.saved))
  const error = ref<string | null>(null)
  function cancel() {
    draft.value = copyAppearance(store.saved)
    baseline.value = JSON.stringify(store.saved)
    error.value = null
  }
  // Loads and successful saves establish a new editing baseline.
  watch(() => store.saved, cancel)
  async function save() {
    error.value = null
    try { await store.save(draft.value); cancel() }
    catch (cause) { error.value = cause instanceof Error ? cause.message : 'Could not save appearance.' }
  }
  return { store, draft, error, dirty: computed(() => JSON.stringify(draft.value) !== baseline.value), cancel, save }
}
